import { Injectable } from '@angular/core';

export type ResourceType = (params: any) => string;

export interface Resource {
  [key: string]: ResourceType;
}

export interface ValidationResource {
  getMessage(key: string, params: any): string;
}

@Injectable({
  providedIn: 'root',
})
export class ValidationResourceProvider implements ValidationResource {
  private resource: Resource;

  constructor() {
    this.resource = {
      email: (): string => 'E-mail inválido.',
      required: (): string => 'Campo obrigatório.',
      min: ({ min }): string => `Valor mínimo de ${min}`,
      max: ({ max }): string => `Valor máximo de ${max}`,
      minlength: ({ requiredLength }): string => `Digite no mínimo ${requiredLength} caracteres.`,
      maxlength: ({ requiredLength }): string => `Digite no máximo ${requiredLength} caracteres.`,
      mismatch: (): string => 'As senhas não são iguais.',
      password: (): string =>
        'Escolha uma senha segura. Use uma combinação de letras maiúscula, minúsculas, números, com no mínimo de 8 caracteres.',
      pattern: (): string => 'Valor inválido'
    };
  }

  getMessage(key: string, params: any): string {
    const callback: ResourceType = this.resource[key];

    if (!callback) {
      return '';
    }

    return callback(params);
  }
}
